
import { Avatar, Box } from "@mui/material";
import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { adminManagementTableRow } from "../../types";
import { useStyles } from "./styles";
import { dateFormatter } from "utils/helpers"
import { useNavigate } from "react-router-dom";

type Props = {
  rows: adminManagementTableRow[] | [];
  loading?: boolean;
};

 const AdminManagementTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const nav = useNavigate()
  const styles = useStyles();



  const columns = useMemo(
    () => [
      {
        id: "lastLogin",
        label: t("ADMIN_MANAGEMENT.TABLE.DEPARTURE_DATE"),
        minWidth: 140,
        align: "right",
        format: (row: adminManagementTableRow) => (dateFormatter(row.lastLogin))
      },
      {
        id: "createdAt",
        label: t("ADMIN_MANAGEMENT.TABLE.CREATION_DATE"),
        minWidth: 140,
        align: "right",
        format: (row: adminManagementTableRow) => dateFormatter(row.createdAt),
      },
        {
        id: "status",
        label: t("ADMIN_MANAGEMENT.TABLE.STATUS"),
        minWidth: 100,
        align: "right",
        format: (row: adminManagementTableRow) => (
                  <span className={styles.statusBadge}>
                    {t(`ADMIN_MANAGEMENT.STATUS_VALUES.${row.status.toUpperCase()}`)}
                  </span>
                ),
      },
      {
        id: "department",
        label: t("ADMIN_MANAGEMENT.TABLE.DEPARTMENT"),
        minWidth: 140,
        align: "right",
        format: (row: adminManagementTableRow) => t(row.department)
       },
       {
        id: "email",
        label: t("ADMIN_MANAGEMENT.TABLE.EMAIL"),
        minWidth: 160,
        align: "right",
      },
      {
        id: "mobileNumber",
        label: t("ADMIN_MANAGEMENT.TABLE.PHONE"),
        minWidth: 120,
        align: "right",
      },
       {
        id: "role",
        label: t("ADMIN_MANAGEMENT.TABLE.ROLE"),
        minWidth: 120,
        align: "right",
        format: (row: adminManagementTableRow) => t(row.role),
      },
      {
        id: "fullName",
        label: t("ADMIN_MANAGEMENT.TABLE.FULL_NAME"),
        minWidth: 140,
        align: "right",
         format: (row:adminManagementTableRow) => (
          <Box className={styles.contactCell}>
            <span>{t(row.fullName)}</span>
            <Avatar className={styles.avatar}>{row.initials}</Avatar>
          </Box>
        ),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root}>
      <DataTable
        rows={rows || []}
        columns={columns}
        onRowClick={(row: adminManagementTableRow) => nav(`/users/${row.userID}`)}
        loading={loading}
        serialEnabled={false}
        isPointerCursor
      />
    </div>
  );
};

export default AdminManagementTable;
